import { createContext, useContext } from 'react';
import { useDerivedCohortInfo } from '../hooks/useDerivedCohortInfo';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_VALUE = {
  loading: true,
  isUngatedForSeats: false,
  isHubSpotOnCredits: false,
  hasMismatchedProductsAndPopData: false,
  mismatchedProductsAndPopDataMetrics: undefined
};
const DerivedCohortInfoContext = /*#__PURE__*/createContext(DEFAULT_VALUE);
export const DerivedCohortInfoProvider = ({
  children
}) => {
  const value = useDerivedCohortInfo();
  return /*#__PURE__*/_jsx(DerivedCohortInfoContext.Provider, {
    value: value,
    children: children
  });
};
export const useDerivedCohortInfoContext = () => useContext(DerivedCohortInfoContext);